import React, { useEffect, useState } from "react";
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";

import CustomTable from "../../uiKit/CustomTable/customTable";
import RowRenderer from "./tableRow";

import { clearMember, getMembers } from "../../redux/state/memberSlice";

const MembersTable = () => {

    const dispatch = useDispatch();
    const { pathname } = useLocation();

    const members = useSelector(state => state.member.members, shallowEqual);
    const communityId = useSelector(state => state.community.community.id, shallowEqual);
    const isLoading = useSelector(state => state.member.isLoading.members, shallowEqual);

    const [paginationData, setPaginationData] = useState({
        pageSize: 8,
        page: 1
    });
    useEffect(() => {
        dispatch(clearMember());
    }, [dispatch])

    useEffect(() => {
        if (!!paginationData && !!communityId) {
            dispatch(getMembers({ ...paginationData, communityId }))
        }
    }, [paginationData, communityId, dispatch])

    return (
        <div className='membersTableWrapper'>
            <CustomTable
                RowRenderer={RowRenderer}
                headerArray={[
                    { name: '' },
                    { name: 'Name' },
                    { name: 'Phone' },
                    { name: 'Email' },
                    { name: 'Status' }
                ]}
                data={members}
                url={pathname}
                setPaginationData={setPaginationData}
                isLoading={isLoading}
                scrollToY={500}
            />
        </div>
    )
}

export default MembersTable;